import MvGallery from './responsive/hotel_detail/MvGallery';
import Nav from "./responsive/hotel_detail/Nav";
import Util from "./responsive/libs/Util";
import DialogGallery from "./responsive/hotel_detail/DialogGallery";
import DialogMap from "./responsive/hotel_detail/DialogMap";
import ToolTip from "./responsive/hotel_detail/ToolTip";
import MoreToggle from "./responsive/libs/MoreToggle";
import DialogReviews from "./responsive/hotel_detail/DialogReviews";
import PlanListMg from "./responsive/hotel_detail/PlanListMg";
import DialogRoomDetail from "./responsive/hotel_detail/DialogRoomDetail";
import BtnScrollTop from "./responsive/libs/BtnScrollTop";
import Gnav from "./responsive/libs/Gnav";

/**
 * ホテル詳細 IT-01-1-1
 */
class IH0111PageClass {
  constructor() {
    Util.setAnchor();

    const mvGallery = new MvGallery();
    const nav = new Nav();
    const dialogGallery = new DialogGallery();
    const dialogMap = new DialogMap();
    const dialogReviews = new DialogReviews();
    const dialogRoomdetail = new DialogRoomDetail();
    const tooltip = new ToolTip();

    const btnScrollTop = new BtnScrollTop();
    const gnav = new Gnav();

    const planListMg = new PlanListMg();
    planListMg.el.addEventListener(PlanListMg.EVENT_LIST_RELOAD,(e)=>{
      tooltip.addEvent(planListMg.insertTarget);
      Util.setAnchor(planListMg.insertTarget);
      dialogRoomdetail.addEvent(planListMg.insertTarget,e.detail);
    });

    const mores = [];
    document.querySelectorAll('.js-more').forEach(el => {
      mores.push(new MoreToggle(el));
    });
    window.addEventListener('resize', this.onResize.bind(this));
    this.onResize();

    planListMg.updateLocalStorageItem();

    this.reloadAction();
  }

  onResize(){
    if(document.querySelector("html").style.overflow !== "hidden"){
      const sw = Util.getWindowScrollWidth();
      document.documentElement.style.setProperty( '--wsw', sw + 'px');
    }
  }

  reloadAction() {
    setTimeout(() => {
      alert(LtikeCommon.HOTEL.TEXT.TIMEOUT_ERROR);
      const urlParams = new URLSearchParams(window.location.search);
      const urlCatalogid = urlParams.get('catalogid');
      const urlAccesskey = urlParams.get('accesskey');

      if (!!urlCatalogid && !!urlAccesskey) {
        const atDate = new Date();
        const url = window.location.href;

        // 再検索用URLを取得
        const searchUrl = Util.getHotelsDetailSearchUrl(url, atDate);
        window.location.href = searchUrl;
      } else {
        window.location.reload();
      }
    }, LtikeCommon.HOTEL.RELOAD_TIME);
  }
}
export const pageJs = new IH0111PageClass();
